import { render, staticRenderFns } from "./eventCard.vue?vue&type=template&id=3e67f245&scoped=true&"
import script from "./eventCard.vue?vue&type=script&lang=js&"
export * from "./eventCard.vue?vue&type=script&lang=js&"
import style0 from "./eventCard.vue?vue&type=style&index=0&id=3e67f245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e67f245",
  null
  
)

export default component.exports